export const LOCAL_STORAGE_CURRENT_ORG = "local_storage_current_org";
export const LOCAL_STORAGE_CURRENT_ACCOUNT = "local_storage_current_account";
export const LOCAL_STORAGE_CURRENT_USER = "local_storage_current_user";
export const LOCAL_STORAGE_INVITE_CODE = "local_storage_invite_code";
export const LOCAL_STORAGE_UPDATED_AT = "local_storage_updated_at";

export const getLocalStorage = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (error) {
    return null;
  }
};

export const setLocalStorage = (key, value) => {
  try {
    return localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    return null;
  }
};

export const deleteLocalStorage = (key) => {
  try {
    return localStorage.removeItem(key);
  } catch (error) {
    return null;
  }
};

export const shouldRefreshOrgData = () => {
  try {
    const lastUpdated = getLocalStorage(LOCAL_STORAGE_UPDATED_AT);
    if (!lastUpdated) return true;

    const lastUpdatedDate = new Date(lastUpdated);
    const currentDate = new Date();
    
    // Check if difference is more than 5 minutes
    const timeDiffInMinutes = (currentDate - lastUpdatedDate) / (1000 * 60);
    return timeDiffInMinutes > 5;
  } catch (error) {
    return true;
  }
};
